import { useState } from "react";
import { Box } from "@mui/material";
import { useToast } from "../../../../../Hooks/UseToast";
import { useProveedores } from "../hooks/useProveedores";
import { cambiarEstadoProveedor } from "../service/proveedoresService";
import ProveedoresTable from "../components/ProveedoresTable";
import ModalManager from "../modals/ModalManager";
import { MODAL_TYPES } from "../config/MODAL_TYPES";
import { ROW_ACTIONS } from "../config/ROW_ACTIONS";

const ProveedoresPage = () => {
  const { data, loading, refresh } = useProveedores();
  const { showToast, Toast } = useToast();
  const [modal, setModal] = useState(null);

  const openModal = (type, props = {}) => setModal({ type, ...props });
  const closeModal = () => setModal(null);

  const handleAction = async ({ type, row }) => {
    switch (type) {
      case ROW_ACTIONS.EDITAR:
        openModal(MODAL_TYPES.FORM, { proveedor: row });
        break;

      case ROW_ACTIONS.SUCURSALES:
        openModal(MODAL_TYPES.SUCURSALES, { proveedor: row });
        break;

      case ROW_ACTIONS.TOGGLE_ESTADO: {
        const nuevoEstado = Number(row.activo) === 1 ? 0 : 1;
        try {
          await cambiarEstadoProveedor(row.id, nuevoEstado);
          showToast(
            nuevoEstado ? "Proveedor activado." : "Proveedor desactivado.",
            "success",
          );
          refresh();
        } catch (err) {
          showToast(err.message || "Error al cambiar el estado.", "error");
        }
        break;
      }

      default:
        break;
    }
  };

  return (
    <Box>
      <ProveedoresTable
        data={data}
        loading={loading}
        onAction={handleAction}
        onNuevo={() => openModal(MODAL_TYPES.FORM, { proveedor: null })}
      />

      <ModalManager modal={modal} onClose={closeModal} refresh={refresh} showToast={showToast} />
      {Toast}
    </Box>
  );
};

export default ProveedoresPage;
